<template>
  <span class="mx-1">
    <v-icon
        :color="errorData.iconColor"
        :title="errorMessage"
    >
      {{ errorData.icon }}
    </v-icon>
    <span v-if="!onlyIcon" class="ml-2">{{ errorMessage }}</span>
  </span>
</template>

<script>

import {LocaleUtils} from '@/utils/locale-utils';
import {BookingValidationErrors, colorError} from '@/lib/booking-validation-errors';

export default {
  name: 'BookingValidationError',
  components: {},
  mixins: [
    LocaleUtils
  ],
  props: {
    value: {
      required: true,
      type: Number
    },
    booking: {
      type: Object
    },
    onlyIcon: {
      type: Boolean
    }
  },
  computed: {
    errorData () {
      for(const errorData of Object.values(BookingValidationErrors)) {
        if(errorData.value === this.value) {
          return errorData;
        }
      }

      return {
        translationKey: 'error.unknownError',
        icon: 'mdi-alert',
        iconColor: colorError
      };
    },
    errorMessage() {
      let customMessage = null;
      if(this.booking != null) {
        if(this.value == BookingValidationErrors.BOOKING_NOTE_PRESENT.value) {
          customMessage = this.trans('settlement.notePresent')+':';

          if (this.booking.notesAdditional) {
            customMessage += "\n\n";
            customMessage += ('"' + this.booking.notesAdditional + '"');
          }

          if (this.booking.notesCaretaker) {
            customMessage += ("\n\n" + this.trans('settlement.notesCaretaker') + ":\n");
            customMessage += ('"' + this.booking.notesCaretaker + '"');
          }
        }
      }

      return customMessage || this.transSingular(this.errorData.translationKey);
    }
  },
}
</script>
